import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import * as ep from '../api/endpoints';
import { useMe } from '../app/auth';
import { PeriodPicker } from '../components/PeriodPicker';
import { ErrorBox, Loading, Money, ReceiptBadge } from '../components/ui';
import { formatDate, yearMonthLabel } from '../lib/dates';
import { formatTL } from '../lib/money';

/** Kişiler: ad-soyad, o dönem fiş adedi ve net toplam; kendi hesabına hızlı erişim (PDF §04). */
export function PeopleScreen() {
  const me = useMe();
  const members = useQuery({ queryKey: ['members'], queryFn: ep.members });
  const [periodId, setPeriodId] = useState<string | undefined>();
  const dash = useQuery({ queryKey: ['dashboard', periodId], queryFn: () => ep.dashboard(periodId) });
  return (
    <div>
      <div className="row">
        <h1 style={{ margin: 0 }}>Kişiler</h1><span className="spacer" />
        <div style={{ minWidth: 200 }}><PeriodPicker value={periodId ?? dash.data?.period.id} onChange={setPeriodId} /></div>
      </div>
      <p><Link className="btn" to={`/kisiler/${me.user.id}${periodId ? `?period_id=${periodId}` : ''}`}>Benim fişlerim</Link></p>
      <ErrorBox error={members.error} />
      {!members.data ? <Loading /> : (
        <div className="card">
          <ul className="list">
            {members.data.map((m) => (
              <PersonRow key={m.user_id} userId={m.user_id} name={m.full_name} active={m.is_active} periodId={periodId ?? dash.data?.period.id} />
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

function PersonRow({ userId, name, active, periodId }: { userId: string; name: string; active: boolean; periodId?: string }) {
  const q = useQuery({ queryKey: ['person', userId, periodId], queryFn: () => ep.personSummary(userId, periodId), enabled: !!periodId });
  return (
    <li>
      <Link to={`/kisiler/${userId}${periodId ? `?period_id=${periodId}` : ''}`}>
        <div style={{ flex: 1 }}>
          <div className="title">{name}{!active && <span className="badge" style={{ marginLeft: 6 }}>Pasif</span>}</div>
          <div className="small muted">{q.data ? `${q.data.active_count} fiş` : '…'}</div>
        </div>
        {q.data && <Money value={q.data.totals.net_kurus} />}
      </Link>
    </li>
  );
}

export function PersonDetailScreen() {
  const { userId = '' } = useParams();
  const search = new URLSearchParams(window.location.search);
  const [periodId, setPeriodId] = useState<string | undefined>(search.get('period_id') ?? undefined);
  const q = useQuery({ queryKey: ['person', userId, periodId], queryFn: () => ep.personSummary(userId, periodId) });
  const d = q.data;
  return (
    <div className="stack">
      <div className="row">
        <h1 style={{ margin: 0 }}>{d?.name ?? 'Kişi'}</h1><span className="spacer" />
        <div style={{ minWidth: 200 }}><PeriodPicker value={periodId ?? d?.period.id} onChange={setPeriodId} /></div>
      </div>
      <ErrorBox error={q.error} />
      {!d ? <Loading /> : (
        <>
          <div className="row small muted">{yearMonthLabel(d.period.year_month)} · {d.active_count} aktif fiş · Net <Money value={d.totals.net_kurus} /></div>
          <div className="card scroll-x">
            <table className="t">
              <thead><tr><th>Tarih</th><th>Açıklama</th><th>Kategori</th><th>Durum</th><th className="num">Bu aya etkisi</th></tr></thead>
              <tbody>
                {d.rows.map((r) => (
                  <tr key={r.receipt_id}>
                    <td>{formatDate(r.document_date)}</td>
                    <td><Link to={`/fis/${r.receipt_id}`}>{r.description || '—'}</Link>{r.source_period && <span className="badge warn" style={{ marginLeft: 6 }}>Kaynak: {r.source_period}</span>}</td>
                    <td>{r.category}</td>
                    <td><ReceiptBadge status={r.status} /></td>
                    <td className={`num ${r.period_effect_kurus < 0 ? 'neg' : ''}`}>{formatTL(BigInt(r.period_effect_kurus))}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
